import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import type {
  LatenessSettings,
  LatenessSettingsRequest,
} from '../entities/lateness-settings.model';

@Injectable({ providedIn: 'root' })
export class LatenessSettingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<LatenessSettings> {
    return this.http.get<LatenessSettings>(`${this.baseUrl}/LatenessSettings`, {
      withCredentials: true,
    });
  }

  public update(body: LatenessSettingsRequest): Observable<LatenessSettings> {
    return this.http.put<LatenessSettings>(`${this.baseUrl}/LatenessSettings`, body, {
      withCredentials: true,
    });
  }
}
